import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.timetable';

const translations = {
    'timetable': 'Idősávok',
    'range_date.title': 'Dátum',
    'timeRange.id.title': 'Idősáv ID',
    'sector.name.title': 'Szektor',
    'timeRange.title': 'Idősáv',
    'price.title': 'Ár',
    'order_limit.title': 'Rendelés limit',
    'weight_limit.title': 'Össztömeg limit',
    'status.title': 'Státusz',
    'reserved_order_count.title': 'Rendelés foglalva',
    'linked_orders.title': 'Kapcsolt',
    'parent_order.title': 'Szülő',
    'reserved_weight_count.title': 'Össztömeg foglalva',

    'status.ACTIVE': 'Aktív',
    'status.INACTIVE': 'Inaktív',
    'status.FULL': 'Betelt',
    'status.all': 'Összes státusz',

    'forenoon': 'Délelőtt',
    'afternoon': 'Délután',
    'linked_orders.modal': 'Kapcsolt megrendelések',
    'reserved_order_count.modal': 'Megrendelések',

    'dailySummary': 'Napi összesítés',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Timetable/lang/hu.ts